// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.batch_clearance_status_enum */
var BatchClearanceStatusEnum;
(function (BatchClearanceStatusEnum) {
    BatchClearanceStatusEnum["PENDING_TESTS"] = "PENDING_TESTS";
    BatchClearanceStatusEnum["TESTS_IN_PROGRESS"] = "TESTS_IN_PROGRESS";
    BatchClearanceStatusEnum["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    BatchClearanceStatusEnum["CLEARED"] = "CLEARED";
    BatchClearanceStatusEnum["REJECTED"] = "REJECTED";
    BatchClearanceStatusEnum["CONDITIONALLY_CLEARED"] = "CONDITIONALLY_CLEARED";
    BatchClearanceStatusEnum["ON_HOLD"] = "ON_HOLD";
})(BatchClearanceStatusEnum || (BatchClearanceStatusEnum = {}));
;
export default BatchClearanceStatusEnum;
/** Zod schema for batch_clearance_status_enum */
export const batchClearanceStatusEnum = z.nativeEnum(BatchClearanceStatusEnum);
//# sourceMappingURL=BatchClearanceStatusEnum.js.map